import { useGlobalContext } from "../../GlobalContext";
import { toast } from "sonner";

export default function useKYCImageUpload() {
  const { packkyApi, AdminId } = useGlobalContext();

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = String(reader.result || "");

        // API expects raw base64 only.
        const base64 = result.includes(",")
          ? result.substring(result.indexOf(",") + 1)
          : result;

        resolve(base64);
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const uploadImageToServer = async (file, userId, type, itemName) => {
    if (!file) return "";

    if (typeof file === "string") return file;

    const cleanUserId = String(userId || "").trim();
    const cleanItemType = String(type || "").trim();

    if (!cleanUserId) {
      toast.error("User ID is required for image upload");
      return "";
    }

    if (!cleanItemType) {
      toast.error("Image type is required");
      return "";
    }

    if (!(file instanceof File)) {
      toast.error("Please select a valid image file");
      return "";
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image too large (max 5MB)");
      return "";
    }

    if (!packkyApi) {
      toast.error("Packky image upload API is not configured");
      return "";
    }

    try {
      const base64 = await fileToBase64(file);

      const payload = {
        adminId: String(AdminId || ""),
        image_data: base64,
        item_name: itemName || `${cleanUserId}_${cleanItemType}`,
        type: "IMG",
        userid: cleanUserId,
      };

      console.log("KYC IMAGE UPLOAD REQUEST:", {
        ...payload,
        image_data: `${base64.slice(0, 80)}...`,
      });

      const res = await packkyApi.post("/v1/uploadKycImagev2.php", payload);

      console.log("KYC IMAGE UPLOAD RESPONSE:", res?.data);

      if (String(res?.data?.status) === "0") {
        const imageUrl =
          res?.data?.image_url ||
          res?.data?.imageUrl ||
          res?.data?.url ||
          res?.data?.data?.image_url ||
          res?.data?.data?.imageUrl ||
          res?.data?.data?.url ||
          "";

        if (!imageUrl) {
          throw new Error("Image URL not received from upload API");
        }

        return imageUrl;
      }

      throw new Error(res?.data?.msg || res?.data?.message || "Upload failed");
    } catch (err) {
      console.error("uploadImageToServer error:", err?.response?.data || err);

      toast.error(
        err?.response?.data?.msg ||
          err?.response?.data?.message ||
          err?.message ||
          "Image upload failed",
      );

      throw err;
    }
  };

  return {
    uploadImageToServer,
  };
}
